/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState, useRef } from 'react'

import { networkConnected, networkSignal } from '../utils/networkConnected'

const useNetworkIsAvailable = () => {
  const [networkIsAvailable, setNetworkIsAvailable] = useState(true)
  const [networkSpeed, setNetworkSpeed] = useState(0)
  const pingRef = useRef()

  const startPinging = () => {
    stopPinging()
    const ping = () => networkConnected().then(() => setNetworkIsAvailable(true)).catch(() => setNetworkIsAvailable(false)).then(() => networkSignal(setNetworkSpeed))

    ping()
    pingRef.current = setInterval(ping, 10000)
  }

  const stopPinging = () => {
    clearInterval(pingRef.current)
    pingRef.current = undefined
  }

  useEffect(() => {
    const updateAvailability = (event) => {
      const available = event.type === "online"

      if (available && !pingRef.current) startPinging()
      if (!available && pingRef.current) stopPinging()

      setNetworkIsAvailable(available)
    }

    if (navigator.onLine) {
      startPinging()
    } else {
      setNetworkIsAvailable(false)
    }

    window.addEventListener('offline', updateAvailability)
    window.addEventListener('online', updateAvailability)

    return () => {
      stopPinging()
      window.removeEventListener('online', updateAvailability)
      window.removeEventListener('offline', updateAvailability)
    }
  }, [])

  return [networkIsAvailable, networkSpeed]
}

export default useNetworkIsAvailable
